export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    unitId() {
      return this.$f7route.params.unitId
    },
    unit() {
      return this.$f7.data.units[this.unitId] || {}
    }
  },
  methods: {
    getUnit(event, done) {
      return new Promise((resolve, reject) => {
        console.log('Getting unit in mixin')
        const app = this.$f7
        const instance = this
  
        this.loading = true
        app.dialog.preloader('Laddar..')
        this.$request.json(`/api/units/${this.unitId}`, (data, status) => {
          app.dialog.close()
          if (data.unit) {
            console.log('Setting unit in mixin')
            this.$set(app.data.units, this.unitId, data.unit)
          }
          this.loading = false
          if (done) done()
          return resolve()
        }, (xhr, status) => {
          app.dialog.close()
          if (status === 401) {
            app.dialog.alert('Du har inte åtkomst')
          }
          this.loading = false
          if (done) done()
          return resolve()
        })
      })
    },
  },
  async mounted() {
    if (!this.$f7.data.units[this.unitId]) {
      await this.getUnit()
      console.log('Mixin mounted done')
      return
    }

    return
  }
}